//copied from VPC
import * as React from 'react';
import { L10n } from '../../../../common/utils/L10n';

import { DetailsTooltipStyles } from '../DetailsTooltipStyles';

export interface Timestamp {
  label: string;
  value: Date;
}

export function Timestamp(props: Timestamp) {
  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span>{props.label}</span>
      <span className={DetailsTooltipStyles.MetadataValue}>{L10n.localizedDateTime(props.value)}</span>
    </div>
  );
}
